(function(){
  var toastEl, timer;
  function toast(msg, ms){
    toastEl = toastEl || document.getElementById('toast');
    if(!toastEl) return;
    toastEl.innerHTML = msg; toastEl.classList.add('show');
    clearTimeout(timer); timer = setTimeout(function(){ toastEl.classList.remove('show'); }, ms || 2600);
  }
  window.bbToast = toast;
  var T = window.theme || {};
  function money(cents){ return '$' + (cents / 100).toFixed(2); }
  function store(k, v){ try { if(v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch(e){ return null; } }

  // mobile menu
  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-menu-toggle]');
    if(!t) return;
    var h = t.closest('.header'); var open = h.classList.toggle('is-open');
    t.setAttribute('aria-expanded', open);
  });

  // ajax add to bag
  document.addEventListener('submit', function(e){
    var form = e.target.closest('form[data-ajax-cart]');
    if(!form || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]'); if(btn) btn.disabled = true;
    fetch(window.routes.cart_add_url + '.js', { method:'POST', headers:{ 'Accept':'application/json' }, body:new FormData(form) })
      .then(function(r){ return r.json().then(function(j){ return { ok:r.ok, j:j }; }); })
      .then(function(res){
        if(!res.ok){ toast(res.j.description || 'That one could not be added.'); return; }
        if(form.hasAttribute('data-reload')){ location.reload(); return; }
        return fetch(window.routes.cart_url + '.js').then(function(r){ return r.json(); }).then(function(cart){
          document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = cart.item_count; });
          var left = (T.freeShip || 0) - cart.total_price;
          var msg = 'Added to your haul! ';
          msg += left > 0 ? 'You’re ' + money(left) + ' from free shipping.' : 'Your haul ships free 🎉';
          toast(msg + ' <a href="' + window.routes.cart_url + '">View bag</a>', 4200);
        });
      })
      .catch(function(){ form.submit(); })
      .finally(function(){ if(btn) btn.disabled = false; });
  });

  // variant picker (hidden select, driven by the swatch / pill buttons)
  document.addEventListener('change', function(e){
    var sel = e.target.closest('[data-variant-select]');
    if(!sel) return;
    var opt = sel.options[sel.selectedIndex];
    var scope = sel.closest('[data-product]');
    var available = opt.getAttribute('data-available') === 'true';
    var price = scope.querySelector('[data-price]');
    if(price) price.innerHTML = opt.getAttribute('data-price-html');
    scope.querySelectorAll('[data-opt-label]').forEach(function(el){ el.textContent = opt.getAttribute('data-label'); });
    var sp = scope.querySelector('[data-sticky-price]'); if(sp) sp.textContent = opt.getAttribute('data-price-money');
    var btn = scope.querySelector('[data-add-btn]');
    if(btn){
      btn.disabled = !available;
      var label = btn.querySelector('[data-btn-label]') || btn;
      label.textContent = available ? btn.getAttribute('data-label') : 'Sold out';
      var bp = btn.querySelector('[data-btn-price]');
      if(bp){ bp.textContent = opt.getAttribute('data-price-money'); bp.hidden = !available; }
    }
    var sb = scope.querySelector('[data-sticky-add]');
    if(sb){ sb.disabled = !available; sb.textContent = available ? 'Add to bag' : 'Sold out'; }
    var save = scope.querySelector('[data-save]');
    if(save){
      var s = opt.getAttribute('data-save-money');
      save.hidden = !s; save.textContent = s ? 'Save ' + s : '';
    }
  });
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-opt]');
    if(!b) return;
    var scope = b.closest('[data-product]');
    var sel = scope.querySelector('[data-variant-select]');
    if(!sel) return;
    sel.value = b.getAttribute('data-opt');
    sel.dispatchEvent(new Event('change', { bubbles:true }));
    scope.querySelectorAll('[data-opt]').forEach(function(x){ x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
    var img = scope.querySelector('.pp-main img'), src = b.getAttribute('data-img');
    if(img && src){ img.removeAttribute('srcset'); img.src = src; }
    scope.querySelectorAll('[data-thumb]').forEach(function(t){ t.removeAttribute('aria-current'); });
  });

  // product thumbnails swap the main image
  document.addEventListener('click', function(e){
    var th = e.target.closest('[data-thumb]');
    if(!th) return;
    var scope = th.closest('[data-product]');
    var img = scope && scope.querySelector('.pp-main img');
    if(!img) return;
    img.removeAttribute('srcset'); img.src = th.getAttribute('data-src');
    scope.querySelectorAll('[data-thumb]').forEach(function(b){ b.removeAttribute('aria-current'); });
    th.setAttribute('aria-current', 'true');
  });

  // sticky add-to-bag bar (phones only)
  var sticky = document.querySelector('[data-sticky-buy]');
  var mainBuy = document.querySelector('[data-main-buy]');
  if(sticky && mainBuy && 'IntersectionObserver' in window){
    var mq = window.matchMedia('(max-width: 860px)');
    var mainVisible = true;
    var footer = document.querySelector('.footer');
    var footVisible = false;
    function sync(){
      var show = mq.matches && !mainVisible && !footVisible;
      sticky.hidden = false;
      sticky.classList.toggle('is-on', show);
      document.body.classList.toggle('has-sticky', show);
    }
    new IntersectionObserver(function(en){ mainVisible = en[0].isIntersecting; sync(); }).observe(mainBuy);
    if(footer) new IntersectionObserver(function(en){ footVisible = en[0].isIntersecting; sync(); }).observe(footer);
    if(mq.addEventListener) mq.addEventListener('change', sync);
    sticky.querySelector('[data-sticky-add]').addEventListener('click', function(){
      var f = document.getElementById('pp-form');
      if(!f) return;
      if(f.requestSubmit) f.requestSubmit(); else f.dispatchEvent(new Event('submit', { bubbles:true, cancelable:true }));
    });
  }

  // cart: changing a quantity updates the bag
  var qtyTimer;
  document.addEventListener('change', function(e){
    var q = e.target.closest('[data-cart-qty]');
    if(!q) return;
    clearTimeout(qtyTimer);
    qtyTimer = setTimeout(function(){ q.form.submit(); }, 350);
  });

  // ships-by and arrival dates (skips weekends)
  function addBusinessDays(d, n){
    d = new Date(d);
    while(n > 0){ d.setDate(d.getDate() + 1); if(d.getDay() !== 0 && d.getDay() !== 6) n--; }
    return d;
  }
  function subBusinessDays(d, n){
    d = new Date(d);
    while(n > 0){ d.setDate(d.getDate() - 1); if(d.getDay() !== 0 && d.getDay() !== 6) n--; }
    return d;
  }
  function fmt(d, wd){ return d.toLocaleDateString('en-US', wd ? { weekday:'short', month:'short', day:'numeric' } : { month:'short', day:'numeric' }); }
  // Christmas: last order day so the slowest delivery still lands by Dec 22
  function xmasCutoff(maxDays){
    var now = new Date(), target = new Date(now.getFullYear(), 11, 22);
    var cut = subBusinessDays(target, maxDays);
    cut.setHours(23, 59, 59);
    return now <= cut ? cut : null;
  }
  document.querySelectorAll('[data-ship]').forEach(function(box){
    var now = new Date();
    var p = +box.getAttribute('data-process'), mn = +box.getAttribute('data-min'), mx = +box.getAttribute('data-max');
    var by = box.querySelector('[data-ship-by]'), arr = box.querySelector('[data-arrive]');
    if(by) by.textContent = fmt(addBusinessDays(now, p), true);
    if(arr) arr.textContent = fmt(addBusinessDays(now, mn)) + ' - ' + fmt(addBusinessDays(now, mx));
    var cut = xmasCutoff(mx);
    if(cut){
      var x = document.createElement('p');
      x.className = 'pp-ship__xmas';
      x.innerHTML = '🎄 Order by <b>' + fmt(cut, true) + '</b> for Christmas delivery';
      box.appendChild(x);
    }
  });
  document.querySelectorAll('[data-xmas-cutoff]').forEach(function(el){
    var cut = xmasCutoff(+el.getAttribute('data-max') || 8);
    if(!cut) return;
    el.querySelector('[data-xmas-date]').textContent = fmt(cut, true);
    el.hidden = false;
  });
  document.querySelectorAll('[data-hide-after]').forEach(function(el){
    var d = new Date(el.getAttribute('data-hide-after') + 'T23:59:59');
    if(!isNaN(d) && Date.now() > d.getTime()) el.hidden = true;
  });

  // sale countdown (only shows when a real end date is set)
  document.querySelectorAll('[data-sale-end]').forEach(function(bar){
    var end = new Date(bar.getAttribute('data-sale-end')).getTime();
    var clock = bar.querySelector('[data-timer]');
    if(isNaN(end) || end <= Date.now()) return;
    function pad(n){ return (n < 10 ? '0' : '') + n; }
    function tick(){
      var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
      if(s === 0){ bar.hidden = true; clearInterval(iv); return; }
      var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60);
      clock.textContent = (d ? d + 'd ' : '') + pad(h) + 'h ' + pad(m) + 'm ' + pad(s % 60) + 's';
    }
    var iv = setInterval(tick, 1000); tick(); bar.hidden = false;
  });

  // email popup
  var pop = document.querySelector('[data-popup]');
  if(pop){
    var KEY = 'bb_popup_until';
    var success = pop.querySelector('[data-popup-success]');
    var lastFocus;
    function open(){
      if(!pop.hidden) return;
      lastFocus = document.activeElement;
      pop.hidden = false;
      requestAnimationFrame(function(){ pop.classList.add('is-open'); });
      document.documentElement.classList.add('pop-open');
      var f = pop.querySelector('input[type=email]') || pop.querySelector('.pop__x');
      if(f && !success) setTimeout(function(){ f.focus({ preventScroll:true }); }, 250);
    }
    function close(){
      pop.classList.remove('is-open');
      document.documentElement.classList.remove('pop-open');
      setTimeout(function(){ pop.hidden = true; }, 250);
      store(KEY, String(Date.now() + 7 * 864e5));
      if(lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll:true });
    }
    pop.addEventListener('click', function(e){ if(e.target.closest('[data-popup-close]')) close(); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && !pop.hidden) close(); });
    pop.addEventListener('submit', function(){ store(KEY, String(Date.now() + 365 * 864e5)); });
    var copy = pop.querySelector('[data-copy]');
    if(copy) copy.addEventListener('click', function(){
      try { navigator.clipboard.writeText(copy.getAttribute('data-copy')); copy.querySelector('small').textContent = 'copied!'; } catch(err){}
    });
    var hasErr = pop.querySelector('.pop__err');
    if(success || hasErr){ open(); }
    else {
      var until = +store(KEY) || 0;
      if(Date.now() > until){
        var t = setTimeout(open, (+pop.getAttribute('data-delay') || 8) * 1000);
        window.addEventListener('scroll', function onS(){
          var h = document.documentElement;
          if(h.scrollTop / Math.max(1, h.scrollHeight - h.clientHeight) > 0.5){ clearTimeout(t); window.removeEventListener('scroll', onS); open(); }
        }, { passive:true });
      }
    }
  }
})();
